import classNames from 'classnames'
import { SidebarItem } from 'components/LeftSidebar/components/SideBarContent/constants'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getValidArray } from 'utils/common'
import MenuItemLink from '../MenuItemLink'
import styles from './styles.module.scss'

interface IMenuItemProps {
  item: SidebarItem
  className?: string
  linkClassName: string
  isCondensed?: boolean
}

const MenuItem = ({ item, className, linkClassName, isCondensed }: IMenuItemProps) => {
  const isExpandable = !!item?.children?.length
  const [isExpanded, setIsExpanded] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (isCondensed) {
      setIsExpanded(true)
    }
  }, [isCondensed])

  function rePositionBox(): void {
    const parentY = document.getElementById('highlight-box-expanded')?.getBoundingClientRect().y ?? 0
    const target = document.getElementById('sub-item-wrapper')
    target?.style?.setProperty('bottom', `calc(100vh - ${parentY + 56}px)`)
  }

  useEffect(() => {
    rePositionBox()
    if (isExpandable && isExpanded) {
      document.addEventListener('resize', rePositionBox)
    }

    return () => {
      document.removeEventListener('resize', rePositionBox)
    }
  }, [isExpandable, isExpanded])
  return (
    <li className={classNames('side-nav-item', className, styles.container)}>
      <div className="highlight-box" id={isExpanded && isExpandable ? 'highlight-box-expanded' : ''}>
        <MenuItemLink
          item={item}
          className={classNames(linkClassName, { 'condensed-nav-link-container': isExpandable })}
          arrowClassName={classNames({ 'arrow-expand': isExpanded })}
          isExpanded={isExpanded}
        />
      </div>

      {isExpandable && (
        <button
          className={classNames(styles.expandedButton, 'expand-hidden-btn')}
          onClick={() => setIsExpanded(isCondensed ? true : !isExpanded)}
        />
      )}

      {isExpandable && isExpanded && (
        <div id="sub-item-wrapper" className={classNames('sub-item-wrapper')}>
          {getValidArray(item?.children).map((child, index) => {
            const isChildActive = location.pathname.includes(child.path)

            return (
              <div
                key={child.path + '-' + index}
                className={classNames(
                  styles.highlightBoxChild,
                  { [styles.childActive]: isChildActive },
                  'box-child-condensed'
                )}
              >
                <MenuItemLink
                  nameContainerClassName="sub-item-name-container"
                  item={child}
                  className={classNames(linkClassName, 'sub-item-nav-link', {
                    'sub-item-nav-link-active': isChildActive
                  })}
                  isExpanded={isExpanded}
                />
              </div>
            )
          })}
        </div>
      )}
    </li>
  )
}

export default observer(MenuItem)
